if (!customElements.get('tmg-ymal-slider')) {
  customElements.define(
    'tmg-ymal-slider',
    class TmgYmalSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tmg-ymal__track');
        if (!this.track) return;
        this.querySelector('.tmg-ymal__arrow--prev').addEventListener('click', () => this.step(-1));
        this.querySelector('.tmg-ymal__arrow--next').addEventListener('click', () => this.step(1));
      }

      // One card (card width + gap) per click. At either end the browser clamps the
      // scroll, so the click simply has no effect; the row never loops.
      step(direction) {
        const item = this.track.querySelector('.tmg-ymal__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
      }
    }
  );
}
